import type { CreditExpiry } from "@reactive-resume/dto";
import { format } from "date-fns";

export const PROMO_CREDIT_EXPIRED = "Ce crédit promo a expiré.";
export const PROMO_CREDIT_ADVICE = "Choisissez une offre pour continuer à télécharger.";

// Aucun téléchargement utilisable, et au moins un crédit promo perdu par expiration.
export const isPromoCreditExpired = (balance?: { credit: number; expired: number }) =>
  !!balance && balance.credit <= 0 && balance.expired > 0;

export const describeCreditExpiry = (expiring: CreditExpiry[]) =>
  expiring
    .map(
      ({ remain, expiresAt }) =>
        `${remain} valable${remain > 1 ? "s" : ""} jusqu'au ${format(expiresAt, "dd/MM/yyyy 'à' HH:mm")}`,
    )
    .join(" et ");

export const describePromoCredits = (expiring: CreditExpiry[], expired: number) =>
  [describeCreditExpiry(expiring), expired > 0 ? `${expired} expiré${expired > 1 ? "s" : ""}` : ""]
    .filter(Boolean)
    .join(" · ");
